import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { ReportsService } from '../../../services/reports.service';
import { Constants } from '../../../../../app.const';
import { TranslateService } from 'ng2-translate';

declare var $: any;
@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',

})
export class AttendanceComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() attendanceData: any;
  @Input() leaveData: any; // kauhsalya 2017-09-06 add leave details to chart

  date: string;
  attendance_sheets: any = {
    user_name: [],
    user_times: []
  };

  leave_sheets: any = {
    user_name: [],
    user_times: []
  }
  private constants = Constants;
  constructor(
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    let $this = this;
    let date = new Date();
    // this.getTimeSheetAndAttendanceByDate(this.datePipe.transform(date, this.constants.dateFormat));

    $('.allocationDate').val(this.datePipe.transform(date, this.constants.dateFormat));
    $('.allocationDate').datepicker({
      autoclose: true,
      minViewMode: 0,
      format: this.constants.dateFormatDatepicker,
      endDate: new Date()
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      // get time sheet on chagne
      // $this.getTimeSheetAndAttendanceByDate($this.date);
    });
  }

  /**
   * Attendance chart
   */
  public attendanceChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public attendanceChartLabels: string[] = [];
  public attendanceChartType: string = 'bar';
  public attendanceChartLegend: boolean = true;

  public attendanceChartData: any[] = [
    { data: [], label: 'Attendance' },
    { data: [], label: 'Leave' },
  ];

  public attendanceChartColors: Array<any> = [
    {
      backgroundColor: '#676a6c', // color of attendance
      stack: 'attendance',
    },
     {
      backgroundColor: '#f8ac59', // color of leave
       stack: 'attendance',
    }
  ];
  ngOnChanges() {
    this.attendance_sheets = this.attendanceData;
    this.leave_sheets = this.leaveData;
    this.attendanceChartData = [
      { data: this.attendance_sheets.user_times, label: this.translateService.instant('ATTENDANCE') },
      { data: this.leave_sheets.user_times, label: this.translateService.instant('LEAVE') },
    ];
    this.attendanceChartLegend = true;
    this.attendanceChartLabels = this.attendance_sheets.user_name;

    if (this.chart && this.chart.chart && this.chart.chart.config) {
      this.chart.chart.config.data.labels = this.attendance_sheets.user_name;
      this.chart.chart.update();
    }
  }
  // Attendance
  /**
     * Get timesheet and Attendance by given date for graph  
     * 
     * @param {any} date 
     * 
     * @memberOf TimesheetComponent
     */
  // getTimeSheetAndAttendanceByDate(date) {
  //   this.reportsService.getTimeSheetAndAttendanceByDate({ date }).subscribe(
  //     res => {
  //       this.attendance_sheets = res.data.attendance_sheets;
  //       this.attendanceChartData = [
  //         { data: this.attendance_sheets.user_times, label: 'Attendance ' }
  //       ];
  //       this.attendanceChartLegend = true;
  //       this.attendanceChartLabels = this.attendance_sheets.user_name;

  //       if (this.chart && this.chart.chart && this.chart.chart.config) {
  //         this.chart.chart.config.data.labels = this.attendance_sheets.user_name;
  //         this.chart.chart.update();
  //       }
  //     }
  //   );
  // }
}



// WEBPACK FOOTER //
// ./src/app/modules/reports/components/timesheet/attendance/attendance.component.ts